import { Pipe, PipeTransform } from '@angular/core';
import { EnumService } from '../services/enum.service';

@Pipe({name: 'enumTitle'})

export class EnumTitlePipe implements PipeTransform {
  constructor(private enumService: EnumService) { }

  transform(key: string, enumName: string) {
    const enumObject = this.enumService.getEnum(enumName);
    return enumObject[key] ? enumObject[key].Title : '';
  }
}
